import React from 'react'

import { useTranslation } from '~/app/i18n/client'

type DashboardPaginationProps = {
  requestedPage: number
  totalNumberOfPages: number
  getPrevOrNext: (action: 'prev' | 'next') => void
}

export const DashboardPagination: React.FC<DashboardPaginationProps> = ({
  requestedPage,
  totalNumberOfPages,
  getPrevOrNext,
}: DashboardPaginationProps) => {
  const { t: translate } = useTranslation()

  if (totalNumberOfPages <= 1) {
    return null
  }

  return (
    <div className="flex items-center justify-between gap-2 border-t px-4 py-2">
      <button
        className={`text-sm text-muted-foreground transition-colors hover:text-foreground 
          disabled:cursor-not-allowed disabled:opacity-40`}
        onClick={() => getPrevOrNext('prev')}
        disabled={requestedPage <= 1}
      >
        {translate('pawDashboards.previous')}
      </button>

      <span className="text-xs tabular-nums text-muted-foreground">
        Page {requestedPage} of {totalNumberOfPages}
      </span>

      <button
        className={`text-sm text-muted-foreground transition-colors hover:text-foreground 
          disabled:cursor-not-allowed disabled:opacity-40`}
        onClick={() => getPrevOrNext('next')}
        disabled={requestedPage >= totalNumberOfPages}
      >
        {translate('pawDashboards.next')}
      </button>
    </div>
  )
}
